import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {Link} from 'react-router-dom';

import {fetchUserLastVisitors, resetUserLastVisitors} from "../../creators/user.last-visitors";

import Avatar from './Avatar';
import Icon from './Icon';
import DateSince from "./Date";
import createLink from "../../libs/createLink";
import {SpinLoader} from "./Loader";
import {isNoFollowProfil} from "../../libs/helper";

class LastVisitors extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            reponsiveMoreVisitor: false
        };

        this.props.fetchUserLastVisitors(this.props.userId, {
            limit: 20,
            sort: "-updatedAt",
            isTotal : false
        });
    };

    componentWillUnmount() {
        this.props.resetUserLastVisitors();
    }

    toggleVisitor(){
        this.setState({reponsiveMoreVisitor: !this.state.reponsiveMoreVisitor});
    }

    render() {
        return <div id="recents-activity">
            <div className="card">
                <div className="topline">
                    <span>Derniers Visiteurs</span> <span onClick={() => this.props.handleClose()}><Icon
                    type="close"/></span>
                </div>
                {this.props.userLastVisitorsInitialized ? (
                    <div className="wrapper">
                        {this.props.userLastVisitorsTotal === 0 && (
                            <div className={"no-content"}>Aucun visiteur</div>
                        )}
                        {this.props.userLastVisitors.map((item) => {
                            let relLinkProfil = isNoFollowProfil(item.visitor) ? { rel: "nofollow" } : {};
                            return(
                                <div key={item._id} className="recent-activity">
                                    <Link to={createLink('userProfile', item.visitor)} {...relLinkProfil}>
                                        <Avatar avatar={item.visitor.profile && item.visitor.profile.avatar}
                                                gender={item.visitor.profile && item.visitor.profile.gender}/>
                                    </Link>
                                    <div className="user-infos">
                                        <Link
                                            to={createLink('userProfile', item.visitor)} {...relLinkProfil}>{item.visitor.username || ""}</Link>
                                        <div className="timer">
                                            <DateSince
                                                date={item.updatedAt}
                                                prefix={true}
                                                currentFormat={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                        </div>
                    ) : <SpinLoader className={"small"}/>}
            </div>
        </div>

    }
}

const mapStateToProps = (state) => {
    return {
        userLastVisitors: state.userLastVisitors.data,
        userLastVisitorsLoading: state.userLastVisitors.loading,
        userLastVisitorsInitialized: state.userLastVisitors.initialized,
        userLastVisitorsTotal: state.userLastVisitors.data && state.userLastVisitors.data.length
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserLastVisitors,
    resetUserLastVisitors
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LastVisitors);